import React from "react";
import { Link } from "react-router-dom";

function WAIcon() {
  return (
    <svg className="w-4 h-4 shrink-0" fill="currentColor" viewBox="0 0 24 24">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

const contacts = {
  Opening: [
    { label: "Contact Person", name: "Florentina", href: "https://wa.me/+628156862980" },
    { label: "Contact Person", name: "Christabel", href: "https://wa.me/+628979670377" },
  ],
  "ASIC-Siswa": [
    { label: "Pendaftaran", name: "Mutia", href: "https://wa.me/6285259557699" },
    { label: "Teknis Lomba", name: "Najla", href: "https://wa.me/6285733830683" },
  ],
  "ASIC-Mahasiswa": [
    { label: "Pendaftaran", name: "Nafla", href: "https://wa.me/6285851351004" },
    { label: "Teknis Lomba", name: "Kia", href: "https://wa.me/6285732522576" },
  ],
  ASEC: [
    { label: "Pendaftaran", name: "Nuraniza", href: "https://wa.me/+6285355012230" },
    { label: "Teknis Perlombaan", name: "Abiyyu", href: "https://wa.me/+6281252593363" },
  ],
  ASO: [
    { label: "Pendaftaran", name: "Nayla", href: "https://wa.me/6285755399336" },
    { label: "Teknis Perlombaan", name: "Fauzan", href: "https://wa.me/6285812028365" },
  ],
};

function ContactCard({ event }) {
  const list = contacts[event] ?? [];
  return (
    <div className="flex flex-col gap-4 mb-16 p-6 rounded-2xl bg-gray-50 border border-gray-100 text-left">
      <div className="font-bold text-sm tracking-widest text-gray-400 uppercase">
        Hubungi Kami
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        {/* Email */}
        <a
          href="mailto:arsenunair2026@gmail.com"
          className="flex-1 flex items-center gap-3 p-4 bg-white border border-gray-200 rounded-xl hover:border-arsen-primary hover:shadow-sm transition-all duration-200 group"
        >
          <div className="w-9 h-9 rounded-lg bg-arsen-primary-50 flex items-center justify-center text-arsen-primary shrink-0">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <div>
            <p className="text-xs text-gray-400 font-medium">Email</p>
            <p className="text-sm text-gray-700 font-semibold group-hover:text-arsen-primary transition-colors">arsenunair2026@gmail.com</p>
          </div>
        </a>
      </div>

      {list.length > 0 && (
        <div className="flex flex-col sm:flex-row gap-3">
          {list.map((c) => (
            <Link
              key={c.href}
              to={c.href}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 flex items-center gap-3 p-4 bg-white border border-gray-200 rounded-xl hover:border-green-400 hover:shadow-sm transition-all duration-200 group"
            >
              <div className="w-9 h-9 rounded-lg bg-green-50 flex items-center justify-center text-green-600 shrink-0">
                <WAIcon />
              </div>
              <div>
                <p className="text-xs text-gray-400 font-medium">{c.label}</p>
                <p className="text-sm text-gray-700 font-semibold group-hover:text-green-700 transition-colors">{c.name}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default ContactCard;
